var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.125 13.125V11.875C11.125 11.212 10.8616 10.5761 10.3928 10.1072C9.92393 9.63839 9.28804 9.375 8.625 9.375H3.625C2.96196 9.375 2.32607 9.63839 1.85723 10.1072C1.38839 10.5761 1.125 11.212 1.125 11.875V13.125",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.125 6.875C7.50571 6.875 8.625 5.75571 8.625 4.375C8.625 2.99429 7.50571 1.875 6.125 1.875C4.74429 1.875 3.625 2.99429 3.625 4.375C3.625 5.75571 4.74429 6.875 6.125 6.875Z",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.875 13.125V11.875C14.8746 11.3211 14.6902 10.783 14.3509 10.3452C14.0115 9.90746 13.5363 9.59478 13 9.4563",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.9563C11.0378 2.09399 11.5144 2.40674 11.8548 2.84524C12.1952 3.28375 12.3799 3.82307 12.3799 4.37817C12.3799 4.93328 12.1952 5.4726 11.8548 5.9111C11.5144 6.34961 11.0378 6.66236 10.5 6.80005",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.e62d070507eab2029048c16c750e7c2b.svg";
export { ForwardRef as ReactComponent };